import React, { useEffect } from 'react';
import TutorListPage from "./TutorListPage";
import api from "../../api";

const stripHtml = (s) => String(s || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();

const transform = (row) => {
  const plain = row.message ? stripHtml(row.message) : "";
  const preview = plain.length > 50 ? `${plain.slice(0, 50)}…` : plain;
  return {
    id: row.id,
    title: row.title ?? "-",
    message: preview || "-",
    created_at: row.created_at ?? "-",
  };
};

export default function TutorAnnouncements() {
  // Mark all announcement notifications as read when user views the full announcements page (sidebar count becomes 0)
  useEffect(() => {
    api.post('tutor/notifications/mark-all-announcements-read').catch(() => {});
  }, []);

  return (
    <TutorListPage
      title="Announcements"
      endpoint="tutor/announcements"
      columns={{ id: "ID", title: "Title", message: "Message", created_at: "Date" }}
      transformRow={transform}
    />
  );
}
